import React, { useEffect, useState } from "react";

import {
  Check,
  ChevronDown,
  ChevronUp,
  CircleUserRound,
  Landmark,
  X,
  Infinity
} from "lucide-react";
import coin from "../../assets/images/Coin-Wallet.png";
import Swal from "sweetalert2";

import { Label, TextInput } from "flowbite-react";
import { useAuth } from "../../context/AuthContext";
import { walletApi } from "../../api/wallet";
import { userApi } from "../../api/user";

export default function LoadingStationPopup({ isOpen, onClose, wallet }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [selectedGame, setSelectedGame] = useState("");
  const [selectedGame2, setSelectedGame2] = useState("");
  const [roleId, setRoleId] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [amount, setAmount] = useState("");
  const [details, setDetails] = useState("");

  const [isVisible, setIsVisible] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);
  const { user, tokens } = useAuth();

  const userRoles = [
    { title: "Select User Type", role: "" },
    { title: "Admin", role: 1 },
    { title: "Incorporator", role: 2 },
    { title: "Sub Operator", role: 3 },
    { title: "General Coordinator", role: 4 },
    { title: "Coordinator", role: 5 },
    { title: "Sub Coordinator", role: 6 },
    { title: "Agent", role: 7 },
    { title: "Sub Agent", role: 8 },
    { title: "Player", role: 9 }
  ]

  // Filter roles to only show roles lower than the current user's role
  const filteredUserRoles = userRoles.filter(role => 
    role.role === "" || (role.role > user.roleId)
  );

  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  const fetchUserByRoleId = async (roleId) => {
    const { data, status } = await userApi.getUserByRoleId(tokens.access.token, roleId);
    if (status === 200) {
      setUserList(data);
    }
    console.log(data);
  }

  // if user type dropdown is open, close the Users dropdown
  useEffect(() => {
    if (dropdownOpen) {
      setDropdownOpen2(false);
    }
  }, [dropdownOpen]);

  const selectRole = (roleId) => {
    setRoleId(roleId);
    fetchUserByRoleId(roleId);
  }

  // Manage smooth open and close animations
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10); // Small delay to trigger transition
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300); // Wait for animation to finish
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // Update filtered users when userList or search query changes
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredUsers(userList);
    } else {
      const filtered = userList.filter(user => 
        user.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredUsers(filtered);
    }
  }, [searchQuery, userList]);

  const [isLoading, setIsLoading] = useState(false);

  if (!isVisible) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const sendLoadTransaction = async () => {
    setIsLoading(true);
    const transactionPayload = {
      userId: selectedGame2,
      amount: amount,
      details: details
    }
    const { status, data } = await walletApi.sendLoadTransaction(tokens.access.token, transactionPayload);
    if (status === 200) {
      Swal.fire({
        title: 'Success',
        text: 'Transaction sent successfully',
        icon: 'success'
      });
      onClose();
    } else {
      console.log(data);
      Swal.fire({
        title: 'Error',
        text: 'Transaction failed',
        icon: 'error'
      });
    }
    setIsLoading(false);
  }
  
  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center px-4 z-[60] font-poppins transition-opacity duration-300 ${
        isAnimating ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`relative w-full max-w-sm bg-white rounded-3xl overflow-hidden transform transition-all duration-300 ease-in-out ${
          isAnimating ? "scale-100 opacity-100" : "scale-95 opacity-0"
        } max-h-[90vh] flex flex-col`}
      >
        {/* Header */}
        <div className="flex justify-between items-center py-5 bg-[#0E64D1] rounded-t-3xl text-white px-4">
          <h2 className="font-bold text-center flex-1">Loading Station</h2>
          <button 
            onClick={onClose}
            className="p-1 rounded-full bg-white hover:bg-gray-100 transition-colors"
          >
            <X className="h-5 w-5 text-[#0E64D1]" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="px-4 overflow-y-auto flex-1">
          <div
            className="flex justify-between  rounded-md my-5 text-white"
            style={{
              background: "linear-gradient(180deg, #D92000 0%, #B01A00 100%)",
            }}
          >
            <div className="p-3">
              <p className="text-sm font-normal">WALLET BALANCE</p>
              {user.roleId === 1 ? (
                <Infinity className="h-6" />
              ) : (
                <h3 className="text-2xl font-semibold">₱{wallet?.balance}</h3>
              )}
            </div>

            <div className="flex items-end">
              <img src={coin} alt="coin" />
            </div>
          </div>

          <div className="space-y-4 mb-6">
            <div className="relative">
              <button
                id="dropdownButton"
                className="w-full text-sm px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200 focus:outline-none flex justify-between relative"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <span className="absolute -top-2.5 left-2 z-10 text-[8px] bg-white text-gray-600 font-normal px-1">
                  User Type
                </span>
                <span className="font-light text-sm text-gray-500">
                  {selectedGame || "Select User Type"}
                </span>
                {dropdownOpen ? (
                  <ChevronUp
                    className="h-4 w-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen(false);
                   }}
                  />
                ) : (
                  <ChevronDown
                    className="h-4 w-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen(true);
                    }}
                  />
                )}
              </button>

              {dropdownOpen && (
                <ul className="absolute top-12 left-0 z-30 w-full mt-1 bg-white border rounded-md shadow-lg max-h-48 overflow-y-auto">
                  {filteredUserRoles.map((role, index) => (
                    <li
                      key={role.title}
                      onClick={() => {
                        setSelectedGame(role.title);
                        selectRole(role.role);
                        setDropdownOpen(false);
                      }}
                      className={`flex justify-between p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer 
                        ${index !== 0 ? "border-t border-[#E1E7EF]" : ""}`}
                    >
                      <span>{role.title}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="relative">
              <button
                disabled={userList.length === 0}
                id="dropdownButton"
                className="w-full text-sm px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-200 focus:outline-none flex justify-between relative disabled:bg-gray-100 disabled:cursor-not-allowed"
                onClick={() => setDropdownOpen2(!dropdownOpen2)}
              >
                <span className="absolute -top-2.5 left-2 z-10 text-[8px] bg-white text-gray-600 font-normal px-1">
                  Users
                </span>
                <span className="font-light text-sm text-gray-500">
                  {selectedUser || "Select User"}
                </span>
                {dropdownOpen2 ? (
                  <ChevronUp
                    className="h-4 w-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen2(false);
                    }}
                  />
                ) : (
                  <ChevronDown
                    className="h-4 w-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen2(true);
                    }}
                  />
                )}
              </button>

              {dropdownOpen2 && (
                <div className="absolute top-12 left-0 z-30 w-full mt-1 bg-white border rounded-md shadow-lg">
                  {/* Search Input */}
                  <div className="p-2 border-b">
                    <input
                      type="text"
                      placeholder="Search users..."
                      className="w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-200"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      // Prevent dropdown from closing when clicking the search input
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  
                  {/* Users List */}
                  <ul className="max-h-48 overflow-y-auto">
                    {filteredUsers.length === 0 ? (
                      <li className="p-2.5 text-xs text-gray-500 text-center">
                        {searchQuery ? "No users found" : "No users available"}
                      </li>
                    ) : (
                      filteredUsers.map((user, index) => (
                        <li
                          key={user.id}
                          onClick={() => {
                            setSelectedGame2(user.id);
                            setDropdownOpen2(false);
                            setSelectedUser(user.name);
                            setSearchQuery(""); // Clear search when user is selected
                          }}
                          className={`flex justify-between p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer
                            ${selectedGame2 === user.id ? "bg-[#E1E7EF]" : ""}
                            ${index !== 0 ? "border-t border-[#E1E7EF]" : ""}`}
                        >
                          <span>{user.name}</span>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              )}
            </div>

            <div className="relative">
              <TextInput
                id="amount"
                type="number"
                placeholder="Enter Amount"
                className="w-full rounded-md focus:ring-2 focus:ring-blue-200"
                onChange={(e) => {setAmount(e.target.value)}}
                min="0"
                onKeyDown={(e) => {
                  if (e.key === '-') {
                    e.preventDefault();
                  }
                }}
              />
            </div>

            <div className="relative">
              <TextInput
                id="details"
                type="text"
                placeholder="Transaction Details"
                className="w-full rounded-md focus:ring-2 focus:ring-blue-200"
                onChange={(e) => setDetails(e.target.value)}
              />
            </div>
          </div>

          <div className="sticky bottom-0 bg-white py-4 border-t">
            <button
              type="button"
              className="w-full p-3 bg-[#0E64D1] text-white rounded-lg text-sm hover:bg-blue-600 transition-colors focus:ring-2 focus:ring-blue-200 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed"
              onClick={sendLoadTransaction}
              disabled={!selectedGame2 || !amount || !details || isLoading}
            >
              {isLoading ? "Processing..." : "CONFIRM TRANSACTION"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
